/**
 * Brand mark — angular "S" from Figma (Vector 5, node 2:214).
 * Fills with `currentColor` so the parent controls the colour via `text-*`.
 */
export function Logo({ size = 22, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 471.5 477"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path d="M471.5 81V1L139.5 0L0 141V342.5H95L226.5 210H391.5V260H248.5L144.5 362V477L278 342.5H471.5V132H192L80.5 243.5V172L172 81H471.5Z" />
    </svg>
  );
}
